import React, { useState } from 'react';
import { SearchIcon, MapIcon, FilterIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Header } from '../components/Header';
import { BottomNav } from '../components/BottomNav';
import { VenueCard } from '../components/VenueCard';
import { venues } from '../data/venues';
export function VenuesListScreen() {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedLocation, setSelectedLocation] = useState('all');
  // Extract unique locations
  const locations = ['all', ...Array.from(new Set(venues.map(v => v.location)))];
  // Filter venues
  const filteredVenues = venues.filter(venue => {
    const matchesSearch = venue.name.toLowerCase().includes(searchQuery.toLowerCase()) || venue.location.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesLocation = selectedLocation === 'all' || venue.location === selectedLocation;
    return matchesSearch && matchesLocation;
  });
  return <div className="h-screen w-full flex flex-col bg-[#f8f9fa]" data-id="element-879">
      <Header title="Find Courts" showLogo={true} showNotifications={true} notificationCount={2} onNotificationClick={() => navigate('/notifications')} data-id="element-880" />

      {/* Hero Section */}
      <div className="bg-gradient-to-br from-[#1f5070] to-[#3dc7e3] px-6 py-8" data-id="element-881">
        <h1 className="text-3xl font-bold text-white mb-2" data-id="element-882">Book Your Court</h1>
        <p className="text-white/90 text-base mb-6" data-id="element-883">
          {venues.length} venues •{' '}
          {venues.reduce((sum, v) => sum + v.totalCourts, 0)} courts across
          Brunei
        </p>

        {/* Search Bar */}
        <div className="relative" data-id="element-884">
          <SearchIcon className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" data-id="element-885" />
          <input type="text" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} placeholder="Search venues or locations..." className="w-full pl-12 pr-4 py-3.5 rounded-xl border-0 shadow-lg focus:outline-none focus:ring-2 focus:ring-[#c7f61e] text-[#1f5070] placeholder:text-gray-400" data-id="element-886" />
        </div>
      </div>

      {/* Location Filter Pills */}
      <div className="bg-white px-6 py-4 border-b border-gray-200 shadow-sm" data-id="element-887">
        <div className="flex gap-2 overflow-x-auto scrollbar-hide" data-id="element-888">
          {locations.map(location => <button key={location} onClick={() => setSelectedLocation(location)} className={`px-4 py-2 rounded-full text-sm font-bold whitespace-nowrap transition-all ${selectedLocation === location ? 'bg-[#3dc7e3] text-white shadow-md' : 'bg-gray-100 text-[#1f5070] hover:bg-gray-200'}`} data-id="element-889">
              {location === 'all' ? 'All Locations' : location}
            </button>)}
        </div>
      </div>

      {/* Quick Stats Bar */}
      <div className="bg-white px-6 py-3 border-b border-gray-100" data-id="element-890">
        <div className="flex items-center justify-between text-sm" data-id="element-891">
          <span className="text-[#666666]" data-id="element-892">
            {filteredVenues.length}{' '}
            {filteredVenues.length === 1 ? 'venue' : 'venues'} found
          </span>
          <button onClick={() => navigate('/map')} className="flex items-center gap-1.5 text-[#3dc7e3] font-bold active:scale-95 transition-transform" data-id="element-893">
            <MapIcon className="w-4 h-4" data-id="element-894" />
            Map View
          </button>
        </div>
      </div>

      {/* Venues Grid */}
      <div className="flex-1 overflow-auto px-4 py-4" data-id="element-895">
        {filteredVenues.length > 0 ? <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 max-w-7xl mx-auto pb-4" data-id="element-896">
            {filteredVenues.map(venue => <VenueCard key={venue.id} {...venue} data-id="element-897" />)}
          </div> : <div className="flex flex-col items-center justify-center py-16 text-center" data-id="element-898">
            <div className="w-20 h-20 bg-gray-200 rounded-full flex items-center justify-center mb-4" data-id="element-899">
              <SearchIcon className="w-10 h-10 text-gray-400" data-id="element-900" />
            </div>
            <h3 className="text-xl font-bold text-[#1f5070] mb-2" data-id="element-901">
              No venues found
            </h3>
            <p className="text-[#666666] max-w-xs" data-id="element-902">
              Try adjusting your search or filter to find more venues
            </p>
          </div>}
      </div>

      <BottomNav data-id="element-903" />
    </div>;
}